var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDocumentLightblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 67,
    viewBox: "0 0 60 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 20.1665V63.4765C60.0031 63.9142 59.9199 64.3483 59.7552 64.7539C59.5905 65.1595 59.3476 65.5287 59.0402 65.8404C58.7328 66.1521 58.3671 66.4002 57.9639 66.5705C57.5606 66.7409 57.1277 66.8301 56.69 66.8332H3.31C2.43271 66.8332 1.5913 66.4849 0.970655 65.8649C0.350005 65.2449 0.000883474 64.4038 0 63.5265V3.47317C0 1.68317 1.49667 0.166504 3.34 0.166504H39.99L60 20.1665ZM53.3333 23.4998H36.6667V6.83317H6.66667V60.1665H53.3333V23.4998ZM16.6667 16.8332H26.6667V23.4998H16.6667V16.8332ZM16.6667 30.1665H43.3333V36.8332H16.6667V30.1665ZM16.6667 43.4998H43.3333V50.1665H16.6667V43.4998Z",
    fill: "#C6D5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentLightblue);
export default __webpack_public_path__ + "static/media/icon-document-lightblue.cf7f9ed7fa614b66ebb7f516328624bb.svg";
export { ForwardRef as ReactComponent };